import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=1b284f53&scoped=true&"
import script from "./ControlPanel.vue?vue&type=script&lang=js&"
export * from "./ControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanel.vue?vue&type=style&index=0&id=1b284f53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b284f53",
  null
  
)

export default component.exports